module.exports = __webpack_public_path__ + "static/media/4da49519.jpg";